import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core/settings';
import { EQueriesCountersStorage } from '../../e-queries/e-queries-counters-storage';
import { EQueryCounter } from '../../e-queries/models/e-query-counter';
import { InvestigatorEQueryReadModel } from './investigator-e-query-counter';

@Injectable()
export class InvestigatorEQueriesCountersStorage extends EQueriesCountersStorage implements OnDestroy  {
    constructor(
        settings: Settings,
        http: HttpClient,
    ) {
        super(settings, http);
    }

    public ngOnDestroy() {
        super.dispose();
    }

    protected loadAllCounters(): Observable<EQueryCounter[]> {
        return this.http.get<object[]>(`${this.settings.apiUrl}/investigator/e-query-counters`).pipe(
            map(obj => deserialize(obj, InvestigatorEQueryReadModel)
                .counters
                .map<EQueryCounter>(c => ({
                    key: c.siteId,
                    total: c.total,
                    totalUnresolved: this.createSet(c.totalUnresolved),
                })),
            ),
            publishLast(),
            refCount(),
        );
    }
}
